import { BrowserInfo } from "./browser";
import {v4 as uuid} from "uuid";
import { ElectronFunctions } from "./electron/electron";
import { LoggerService, LogType } from "@/services/logger-service";
import { UserConfigService } from "@/services/user-config-service";

// eslint-disable-next-line max-lines-per-function
export async function printPdf(data:Blob, fileName:string) {
	if (BrowserInfo.isElectron()) {
		await ElectronFunctions.printTempFileWithDialog(data, fileName);
		return;
	}
	var url = URL.createObjectURL(data);

	let iframe = window.document.createElement("iframe") as HTMLIFrameElement;
	iframe.width = "100%";
	iframe.height = "100%";
	if (!BrowserInfo.isChrome() && !BrowserInfo.isSafari() && !BrowserInfo.isFirefox()) {
		iframe.setAttribute("sandbox", "allow-popups allow-scripts allow-same-origin allow-modals " +
				"allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation");
	}
	let frameId = uuid();
	iframe.id = frameId;
	iframe.src = url;
	iframe.name = "PRINTFRAME";
	iframe.style.border = "none";
	iframe.style.position = "absolute";
	iframe.style.display = "block";
	iframe.style.top = "100%";
	window.document.body.appendChild(iframe);
	//if (BrowserInfo.isElectron()){
	//	await triggerIframePrintElectron(iframe);
	//	await ElectronFunctions.deleteTempFile(fileName);
	//}else{
	await triggerIframePrint(iframe);
	URL.revokeObjectURL(url);
	//}
}
/*
async function triggerIframePrintElectron(iframe:HTMLIFrameElement){
	await new Promise<void>((resolve)=>{
		let handler = async (event:any)=>{
			if (event.source != iframe.contentWindow) return;
			if (event.data != "printready") return;
			if (!iframe.contentWindow) return;
			async function eventHandler() {
				iframe.remove();
				resolve();
				window.removeEventListener("mousemove", eventHandler);
			}
			setTimeout(()=>{
				window.addEventListener("mousemove",eventHandler);
			}, 1000);
			window.removeEventListener("message", handler);
		};
		window.addEventListener("message", handler);
	});
}
*/
async function triggerIframePrint(iframe:HTMLIFrameElement){
	const useOptimizedPrinting = UserConfigService.getSaleSettings().OptimizedPrinting;

	if (useOptimizedPrinting) {
		await triggerIframePrintOptimized(iframe);
	} else {
		await triggerIframePrintLegacy(iframe);
	}
}

async function triggerIframePrintOptimized(iframe:HTMLIFrameElement){
	await new Promise<void>((resolve, reject)=>{
		let loaded = false;
		iframe.addEventListener("load", async function () {
			loaded = true;
			iframe.focus();
			const contentWindow = iframe.contentWindow;
			if (!contentWindow) {
				return reject("pdf.ts loaded iframe has no contentWindow");
			}

			let cleaned = false;
			const cleanup = () => {
				if (cleaned) return;
				cleaned = true;
				iframe.remove();
				resolve();
			};

			// Luister naar afterprint event
			contentWindow.addEventListener("afterprint", cleanup, { once: true });
			window.addEventListener("afterprint", cleanup, { once: true });

			// Wacht tot PDF gerenderd is, dan print
			await new Promise(r => setTimeout(r, 1000));
			contentWindow.print();

			// Fallback: mousemove/focus na korte delay als afterprint niet werkt
			setTimeout(() => {
				window.addEventListener("mousemove", cleanup, { once: true });
				window.addEventListener("focus", cleanup, { once: true });
			}, 500);
		});
		setTimeout(()=>{
			if (!loaded) {
				LoggerService.createLog("pdf.ts didn't load the pdf after 6 seconds", "", LogType.WARN);
			}
		}, 6000);
	});
}

// eslint-disable-next-line max-lines-per-function
async function triggerIframePrintLegacy(iframe:HTMLIFrameElement){
	// eslint-disable-next-line max-lines-per-function
	await new Promise<void>((resolve, reject)=>{
		let loaded = false;
		iframe.addEventListener("load", async function () {
			loaded = true;
			iframe.focus();
			let contentWindow = iframe.contentWindow;
			if (!contentWindow) {
				return reject("pdf.ts loaded iframe has no contentWindow");
			};
			for (let i = 0; i < 3; i++) {
				await new Promise(resolve=>setTimeout(resolve, 1000));
				if (!contentWindow) continue;
				contentWindow.print();
				async function eventHandler() {
					iframe.remove();
					if (!BrowserInfo.hasElectronConfigured()){
						resolve();
						window.removeEventListener("mousemove", eventHandler);
					}
				}
				let timeoutDuration = 10000;
				setTimeout(()=>{
					window.addEventListener("mousemove",eventHandler);
				}, timeoutDuration);
				break;
			}
			if (!contentWindow) {
				return reject("pdf.ts loaded iframe in timeout has no contentWindow");
			}
		});
		setTimeout(()=>{
			if (!loaded) {
				LoggerService.createLog("pdf.ts didn't load the pdf after 6 seconds", "", LogType.WARN);
			}
		}, 6000);
	});
}


export async function printHtml(html:string){
	let iframe = document.createElement("iframe") as HTMLIFrameElement;
	iframe.src = `data:text/html;charset=utf-8,${encodeURIComponent(html)}`;
	iframe.width = "100%";
	iframe.height = "100%";
	if (!BrowserInfo.isChrome() && !BrowserInfo.isSafari()) {
		iframe.setAttribute("sandbox", "allow-popups allow-scripts allow-same-origin allow-modals " +
				"allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation");
	}
	let frameId = uuid();
	iframe.id = frameId;
	iframe.name = "PRINTFRAME";
	iframe.style.border = "none";
	iframe.style.position = "absolute";
	iframe.style.display = "block";
	iframe.style.top = "100%";
	await new Promise<void>((resolve, reject)=>{
		iframe.addEventListener("message", (event)=>{
			let ev = event as MessageEvent;
			if (ev.data == "close"){
				resolve();
				iframe.remove();
			}
		});
		window.document.body.appendChild(iframe);
	});
}